<script setup lang="ts"></script>

<template>
  <div class="st-wallet-balance-details__total st-w-100 st-flex-center sc-p-6 sc-bg-400 sc-mb-3">
    <slot name="icon-left" />
    <div class="st-d-flex-column st-flex-fill sc-ml-6">
      <span class="sc-text-caption-2 sc-text-primary-2 st-uppercase">
        <slot name="title" />
      </span>
      <span class="sc-text-h5 sc-text-main-primary">
        <slot name="value" />
      </span>
    </div>
    <div class="st-pointer">
      <slot name="icon-right" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.st-wallet-balance-details {
  &__total {
    border-radius: 2px;
  }
}
</style>
